(() => {
  const root = document.querySelector('[data-r1617-root]');
  if (!root) return;

  const stage = root.querySelector('[data-r1617-stage]');
  const page = root.querySelector('[data-r1617-page]');
  const cta = root.querySelector('[data-r1617-cta]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const moneyFormat =
    (window.Shopify && window.Shopify.money_format) || '{{amount_with_comma_separator}} €';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const value = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return `${value} €`;
  };

  /* —— Langue FR / EN —— */
  const LANG_KEY = 'r1617-lang';
  let currentLang = 'fr';

  const getLang = () => root.getAttribute('data-lang') || 'fr';

  const syncAriaLabels = () => {
    const lang = getLang();
    root.querySelectorAll('[data-r1617-aria-fr]').forEach((el) => {
      const value = el.getAttribute(`data-r1617-aria-${lang}`) || el.getAttribute('data-r1617-aria-fr');
      if (value) el.setAttribute('aria-label', value);
    });
  };

  const syncLangButtons = () => {
    const lang = getLang();
    root.querySelectorAll('[data-r1617-lang-set]').forEach((btn) => {
      const isActive = btn.getAttribute('data-r1617-lang-set') === lang;
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const setLang = (lang) => {
    currentLang = lang === 'en' ? 'en' : 'fr';
    root.setAttribute('data-lang', currentLang);
    try {
      window.localStorage.setItem(LANG_KEY, currentLang);
    } catch (e) {
      /* ignore */
    }
    document.documentElement.lang = currentLang;
    syncLangButtons();
    syncAriaLabels();
    syncMuteUI();
    root.dispatchEvent(new CustomEvent('r1617:langchange', { detail: { lang: currentLang } }));
  };

  try {
    const stored = window.localStorage.getItem(LANG_KEY);
    if (stored === 'en' || stored === 'fr') currentLang = stored;
  } catch (e) {
    /* ignore */
  }
  root.setAttribute('data-lang', currentLang);
  document.documentElement.lang = currentLang;

  root.querySelectorAll('[data-r1617-lang-set]').forEach((btn) => {
    btn.addEventListener('click', () => {
      setLang(btn.getAttribute('data-r1617-lang-set'));
    });
  });

  const atcLabelFor = (btn, key) => {
    if (!btn) return '';
    const lang = getLang();
    const attr = key === 'atc' ? `data-atc-${lang}` : `data-atc-${key}-${lang}`;
    const fallback = key === 'atc' ? 'data-atc-fr' : `data-atc-${key}-fr`;
    return btn.getAttribute(attr) || btn.getAttribute(fallback) || '';
  };

  /* —— Musique (m4a) + volume / mute —— */
  /*
    iOS : HTMLMediaElement.volume est ignoré.
    Volume fin → Web Audio GainNode, mais AudioContext DOIT être créé
    dans le geste utilisateur (CTA). Sinon Safari reste muet.
  */
  const audioUrl = root.getAttribute('data-r1617-audio') || '';
  const volumeRoot = root.querySelector('[data-r1617-volume]');
  const muteBtn = root.querySelector('[data-r1617-mute]');
  const volumeSlider = root.querySelector('[data-r1617-volume-slider]');
  const AudioCtxClass = window.AudioContext || window.webkitAudioContext;

  let musicStarted = false;
  let isMuted = false;
  let volumeLevel = 0.08;
  let sliderDragging = false;
  let bedDucked = false;
  let usingWebAudio = false;
  let audioCtx = null;
  let gainNode = null;
  let audioRaw = null;
  let bufferSource = null;
  let bedEl = null;

  const DEFAULT_VOLUME = 0.08;
  const VOL_KEY = 'r1617-vol-v3';
  const coarsePointer =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: none), (pointer: coarse)').matches;

  try {
    const storedVol = window.localStorage.getItem(VOL_KEY);
    if (storedVol != null) {
      const parsed = Number(storedVol);
      if (!Number.isNaN(parsed)) volumeLevel = Math.max(0, Math.min(1, parsed));
    }
  } catch (e) {
    /* ignore */
  }

  if (audioUrl) {
    bedEl = new Audio();
    bedEl.preload = 'auto';
    bedEl.loop = true;
    bedEl.src = audioUrl;
    try {
      bedEl.volume = volumeLevel;
    } catch (e) {
      /* ignore */
    }
  }

  if (volumeSlider) {
    volumeSlider.value = String(volumeLevel);
  }

  const effectiveLevel = () => {
    if (bedDucked || isMuted || volumeLevel === 0) return 0;
    return volumeLevel;
  };

  const applyBedLevel = () => {
    const level = effectiveLevel();
    if (usingWebAudio && gainNode && audioCtx) {
      try {
        gainNode.gain.cancelScheduledValues(audioCtx.currentTime);
        gainNode.gain.setTargetAtTime(level, audioCtx.currentTime, 0.02);
      } catch (e) {
        gainNode.gain.value = level;
      }
      return;
    }
    if (bedEl) {
      bedEl.muted = level === 0;
      try {
        bedEl.volume = Math.max(0, Math.min(1, volumeLevel));
      } catch (e) {
        /* ignore */
      }
    }
  };

  const syncSliderDisplay = () => {
    if (!volumeSlider || sliderDragging) return;
    const display = isMuted ? 0 : volumeLevel;
    if (Math.abs(Number(volumeSlider.value) - display) > 0.001) {
      volumeSlider.value = String(display);
    }
    volumeSlider.setAttribute('aria-valuenow', String(Math.round(display * 100)));
  };

  const persistVolume = () => {
    try {
      window.localStorage.setItem(VOL_KEY, String(volumeLevel));
    } catch (e) {
      /* ignore */
    }
  };

  const applyVolume = () => {
    applyBedLevel();
    syncSliderDisplay();
    persistVolume();
  };

  const syncMuteUI = () => {
    const muted = isMuted || volumeLevel === 0;
    root.classList.toggle('is-muted', muted);
    root.classList.toggle('is-vol-low', !muted && volumeLevel > 0 && volumeLevel <= 0.35);
    if (muteBtn) {
      const lang = getLang();
      const onKey = muted ? 'mute-on' : 'mute-off';
      const label =
        muteBtn.getAttribute(`data-r1617-${onKey}-${lang}`) ||
        muteBtn.getAttribute(`data-r1617-${onKey}-fr`) ||
        (muted ? 'Activer le son' : 'Couper le son');
      muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      muteBtn.setAttribute('aria-label', label);
    }
    applyVolume();
  };

  syncLangButtons();
  syncAriaLabels();

  /* Loader : fetch uniquement — pas d’AudioContext (sinon iOS mute) */
  const preloadBedAudio = () => {
    if (!audioUrl) return Promise.resolve();
    return fetch(audioUrl, { mode: 'cors', credentials: 'omit' })
      .then((res) => {
        if (!res.ok) throw new Error('audio fetch failed');
        return res.arrayBuffer();
      })
      .then((ab) => {
        audioRaw = ab;
      })
      .catch(() => {
        /* HTMLAudioElement utilisera son propre chargement */
      });
  };

  const decodeAudioData = (ctx, raw) =>
    new Promise((resolve, reject) => {
      const copy = raw.slice(0);
      let settled = false;
      const ok = (buf) => {
        if (settled) return;
        settled = true;
        resolve(buf);
      };
      const fail = (err) => {
        if (settled) return;
        settled = true;
        reject(err || new Error('decode failed'));
      };
      try {
        const result = ctx.decodeAudioData(copy, ok, fail);
        if (result && typeof result.then === 'function') {
          result.then(ok).catch(fail);
        }
      } catch (e) {
        fail(e);
      }
    });

  const startHtmlBed = () => {
    if (!bedEl) {
      musicStarted = false;
      return false;
    }
    usingWebAudio = false;
    applyBedLevel();
    bedEl.play().catch(() => {
      musicStarted = false;
    });
    return true;
  };

  const startWebAudioBed = (ctx, buffer) => {
    gainNode = ctx.createGain();
    gainNode.gain.value = effectiveLevel();
    gainNode.connect(ctx.destination);

    if (bufferSource) {
      try {
        bufferSource.stop();
      } catch (e) {
        /* ignore */
      }
    }

    bufferSource = ctx.createBufferSource();
    bufferSource.buffer = buffer;
    bufferSource.loop = true;
    bufferSource.connect(gainNode);
    bufferSource.start(0);
    usingWebAudio = true;
    applyBedLevel();
  };

  const startMusic = () => {
    if ((!bedEl && !audioRaw) || musicStarted) return;
    musicStarted = true;

    /* HTML d’abord — seul chemin fiable sur Safari iOS */
    startHtmlBed();

    /*
      Upgrade Web Audio (GainNode / slider) uniquement desktop.
      Sur iOS, Web Audio est souvent coupé par le switch silencieux
      alors que HTMLAudioElement continue → on ne bascule pas.
    */
    if (coarsePointer || !AudioCtxClass || !audioRaw) return;

    let ctx;
    try {
      ctx = new AudioCtxClass();
      audioCtx = ctx;
    } catch (e) {
      return;
    }

    const unlocked =
      ctx.state === 'suspended' && typeof ctx.resume === 'function'
        ? ctx.resume()
        : Promise.resolve();

    unlocked
      .then(() => decodeAudioData(ctx, audioRaw))
      .then((buffer) => {
        if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
          return ctx.resume().then(() => buffer);
        }
        return buffer;
      })
      .then((buffer) => {
        try {
          startWebAudioBed(ctx, buffer);
          if (bedEl) {
            try {
              bedEl.pause();
            } catch (e) {
              /* ignore */
            }
          }
        } catch (e) {
          /* garder HTML */
        }
      })
      .catch(() => {
        /* garder HTML */
      });
  };

  const toggleMute = () => {
    if (isMuted || volumeLevel === 0) {
      isMuted = false;
      if (volumeLevel === 0) volumeLevel = DEFAULT_VOLUME;
    } else {
      isMuted = true;
    }
    syncMuteUI();
    if (audioCtx && audioCtx.state === 'suspended') {
      audioCtx.resume().catch(() => {});
    }
    if (musicStarted && !usingWebAudio && bedEl && effectiveLevel() > 0) {
      bedEl.play().catch(() => {});
    }
  };

  if (muteBtn) {
    let muteTapLock = false;
    const onMuteActivate = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (muteTapLock) return;
      muteTapLock = true;
      toggleMute();
      window.setTimeout(() => {
        muteTapLock = false;
      }, 350);
    };

    /* touchend : fiable sur iOS Safari (le click est parfois avalé) */
    muteBtn.addEventListener('touchend', onMuteActivate, { passive: false });
    muteBtn.addEventListener('click', onMuteActivate);
  }

  if (volumeSlider) {
    const onVolumeInput = () => {
      const next = Math.max(0, Math.min(1, Number(volumeSlider.value)));
      volumeLevel = Number.isNaN(next) ? 0 : next;
      isMuted = volumeLevel === 0;
      applyBedLevel();
      persistVolume();
      root.classList.toggle('is-muted', effectiveLevel() === 0);
      root.classList.toggle('is-vol-low', effectiveLevel() > 0 && volumeLevel <= 0.35);
      volumeSlider.setAttribute('aria-valuenow', String(Math.round((isMuted ? 0 : volumeLevel) * 100)));
      if (muteBtn) {
        const muted = effectiveLevel() === 0;
        const lang = getLang();
        const onKey = muted ? 'mute-on' : 'mute-off';
        const label =
          muteBtn.getAttribute(`data-r1617-${onKey}-${lang}`) ||
          muteBtn.getAttribute(`data-r1617-${onKey}-fr`) ||
          (muted ? 'Activer le son' : 'Couper le son');
        muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
        muteBtn.setAttribute('aria-label', label);
      }
      if (audioCtx && audioCtx.state === 'suspended') {
        audioCtx.resume().catch(() => {});
      }
      if (musicStarted && !usingWebAudio && bedEl && effectiveLevel() > 0) {
        bedEl.play().catch(() => {});
      }
    };

    volumeSlider.addEventListener('pointerdown', () => {
      sliderDragging = true;
    });
    volumeSlider.addEventListener('pointerup', () => {
      sliderDragging = false;
      syncSliderDisplay();
    });
    volumeSlider.addEventListener('pointercancel', () => {
      sliderDragging = false;
      syncSliderDisplay();
    });
    volumeSlider.addEventListener('input', onVolumeInput);
    volumeSlider.addEventListener('change', () => {
      sliderDragging = false;
      onVolumeInput();
      syncSliderDisplay();
    });
  }

  if (volumeRoot) {
    /* Mobile : mute seul — pas de panneau slider */
    if (coarsePointer) {
      volumeRoot.classList.add('is-mute-only');
    } else {
      let openTimer = null;
      let autoCloseTimer = null;
      const VOLUME_AUTO_CLOSE_MS = 3200;

      const closeVolumePanel = () => {
        if (sliderDragging) return;
        volumeRoot.classList.remove('is-open');
        window.clearTimeout(autoCloseTimer);
        autoCloseTimer = null;
      };

      const scheduleVolumeAutoClose = () => {
        window.clearTimeout(autoCloseTimer);
        autoCloseTimer = window.setTimeout(closeVolumePanel, VOLUME_AUTO_CLOSE_MS);
      };

      const openVolumePanel = () => {
        volumeRoot.classList.add('is-open');
        scheduleVolumeAutoClose();
      };

      volumeRoot.addEventListener('pointerenter', openVolumePanel);
      volumeRoot.addEventListener('focusin', openVolumePanel);
      volumeRoot.addEventListener('pointerdown', (event) => {
        if (event.target.closest('[data-r1617-mute]')) return;
        openVolumePanel();
      });

      if (volumeSlider) {
        volumeSlider.addEventListener('input', scheduleVolumeAutoClose);
        volumeSlider.addEventListener('change', scheduleVolumeAutoClose);
      }

      volumeRoot.addEventListener('focusout', () => {
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(() => {
          if (!volumeRoot.contains(document.activeElement) && !sliderDragging) {
            closeVolumePanel();
          }
        }, 120);
      });

      document.addEventListener('pointerdown', (event) => {
        if (!volumeRoot.classList.contains('is-open') || sliderDragging) return;
        if (volumeRoot.contains(event.target)) return;
        closeVolumePanel();
      });
    }
  }

  syncMuteUI();

  /* —— Intro reveal —— */
  const pills = root.querySelector('[data-r1617-pills]');
  const videoBlock = root.querySelector('#r1617-video');
  const topbar = root.querySelector('[data-r1617-topbar]');

  const updateTopbarScroll = () => {
    if (!topbar) return;
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    topbar.classList.toggle('is-scrolled', y > 72);
  };

  const updatePillsVisibility = () => {
    if (!pills) return;
    // Jamais visibles avant landing prête / en haut de page (évite le flash post-anim)
    if (!page || page.hidden || !page.classList.contains('is-ready')) {
      pills.classList.remove('is-visible');
      return;
    }
    if (!videoBlock) {
      pills.classList.remove('is-visible');
      return;
    }
    // Apparaît seulement une fois le bloc vidéo dépassé
    const pastVideo = videoBlock.getBoundingClientRect().bottom < window.innerHeight * 0.42;
    pills.classList.toggle('is-visible', pastVideo);
  };

  const unlockPage = () => {
    if (!page) return;

    // Landing visible sous l’iris avant la fermeture du cercle
    page.hidden = false;
    page.classList.add('is-visible');
    root.removeAttribute('data-r1617-locked');
    document.body.classList.remove('r1617-locked');
    window.scrollTo({ top: 0, behavior: 'auto' });
    if (pills) pills.classList.remove('is-visible');
    if (topbar) topbar.classList.remove('is-scrolled');

    if (stage) {
      // Force reflow pour que le clip-path initial soit bien pris en compte
      void stage.offsetWidth;
      stage.classList.add('is-done');
      window.setTimeout(() => {
        stage.hidden = true;
        page.classList.add('is-ready');
        updateTopbarScroll();
        updatePillsVisibility();
      }, 1100);
    } else {
      page.classList.add('is-ready');
      updateTopbarScroll();
      updatePillsVisibility();
    }
  };

  const morphYellow = () => {
    if (!stage) return;
    const dur =
      1000 *
      (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--r1617-dur')) || 1);
    const curve = 'M0,6 L8,-5 L100,-5 L100,108 L42,108 L0,74 Z';
    const rect = 'M0,-5 L100,-5 L100,105 L0,105 Z';

    stage
      .querySelectorAll('.r1617-stage__vband--y1 .r1617-stage__blade, .r1617-stage__vband--y2 .r1617-stage__blade')
      .forEach((path) => {
        try {
          path.animate([{ d: `path("${curve}")` }, { d: `path("${rect}")` }], {
            duration: dur,
            easing: 'cubic-bezier(.65,0,.2,1)',
            fill: 'forwards',
          });
        } catch (error) {
          path.setAttribute('d', rect);
        }
        path.style.transition = `fill ${dur}ms ease`;
        path.setAttribute('fill', '#e6c62c');
      });
  };

  const ctaVideo = root.querySelector('[data-r1617-cta-video]');
  const loader = root.querySelector('[data-r1617-loader]');
  const loaderFill = root.querySelector('[data-r1617-loader-fill]');
  let ctaReady = false;

  let loaderDisplay = 0;
  let loaderTarget = 0;
  let loaderRaf = 0;

  const setLoaderProgress = (ratio) => {
    loaderTarget = Math.max(loaderTarget, Math.max(0, Math.min(1, ratio)));
    if (!loaderFill) return;
    if (loaderRaf) return;
    const tick = () => {
      loaderRaf = 0;
      const delta = loaderTarget - loaderDisplay;
      if (Math.abs(delta) < 0.004) {
        loaderDisplay = loaderTarget;
      } else {
        /* Monte vite au début, ralentit près de la cible (évite le 99% figé) */
        loaderDisplay += delta * (loaderDisplay < 0.7 ? 0.22 : 0.12);
        loaderRaf = window.requestAnimationFrame(tick);
      }
      loaderFill.style.width = `${loaderDisplay * 100}%`;
    };
    loaderRaf = window.requestAnimationFrame(tick);
  };

  const revealCtaScreen = () => {
    if (!stage || ctaReady) return;
    ctaReady = true;
    loaderTarget = 1;
    loaderDisplay = 1;
    if (loaderFill) loaderFill.style.width = '100%';
    stage.classList.add('is-cta-ready');
    if (loader) loader.setAttribute('aria-busy', 'false');

    if (ctaVideo) {
      const playPromise = ctaVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  };

  const warmIntroPhotos = (onProgress) => {
    if (!stage) {
      if (onProgress) onProgress(1);
      return Promise.resolve();
    }

    // Défilement sous loader/vidéo pour forcer decode + GPU
    stage.classList.add('is-photos-live');

    const imgs = Array.from(root.querySelectorAll('.r1617-stage__shot-img'));
    if (!imgs.length) {
      if (onProgress) onProgress(1);
      return Promise.resolve();
    }

    const unique = [];
    const seen = new Set();
    imgs.forEach((img) => {
      const src = img.getAttribute('src') || img.currentSrc || '';
      const srcset = img.getAttribute('srcset') || '';
      const key = src || srcset;
      if (!key || seen.has(key)) return;
      seen.add(key);
      unique.push(img);
      if (src) {
        const pre = new Image();
        pre.decoding = 'async';
        pre.src = src;
      }
    });

    let loaded = 0;
    const total = unique.length || 1;
    const bump = () => {
      loaded += 1;
      if (onProgress) onProgress(Math.min(1, loaded / total));
    };

    return Promise.all(
      unique.map(
        (img) =>
          new Promise((resolve) => {
            const done = () => {
              bump();
              resolve();
            };
            if (img.complete && img.naturalWidth > 0) {
              if (typeof img.decode === 'function') {
                img.decode().then(done).catch(done);
              } else {
                done();
              }
              return;
            }
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
            if (typeof img.decode === 'function') {
              img.decode().then(() => {}).catch(() => {});
            }
          })
      )
    );
  };

  const bootCtaVideo = () => {
    if (!stage) return;

    /* Décode l’audio dès le loader (volume iOS via GainNode) */
    preloadBedAudio();

    let videoRatio = 0;
    let photosRatio = 0;
    let videoReady = false;
    let photosSettled = false;

    const syncCombinedProgress = () => {
      /* Vidéo ~60% de la barre, photos ~40% — plus de saut à 99% puis attente */
      const combined = videoRatio * 0.6 + photosRatio * 0.4;
      setLoaderProgress(Math.min(0.97, combined));
    };

    const photosReady = warmIntroPhotos((ratio) => {
      photosRatio = ratio;
      syncCombinedProgress();
    });

    photosReady.finally(() => {
      photosSettled = true;
      photosRatio = 1;
      syncCombinedProgress();
    });

    // Pas de vidéo → progression photos seule
    if (!ctaVideo) {
      setLoaderProgress(0.12);
      Promise.race([
        photosReady,
        new Promise((resolve) => window.setTimeout(resolve, 2800)),
      ]).then(() => {
        revealCtaScreen();
      });
      return;
    }

    let settled = false;
    const FALLBACK_MS = 10000;
    const MIN_SHOW_MS = 500;
    const PHOTO_WAIT_MS = 1600;
    const startedAt = performance.now();

    const finish = () => {
      if (settled) return;
      if (!videoReady && ctaVideo.readyState < 3) return;

      // Court délai max pour les photos — ne bloque plus plusieurs secondes à 99%
      if (!photosSettled && performance.now() - startedAt < PHOTO_WAIT_MS) {
        window.setTimeout(finish, 100);
        return;
      }

      settled = true;
      const wait = Math.max(0, MIN_SHOW_MS - (performance.now() - startedAt));
      window.setTimeout(revealCtaScreen, wait);
    };

    const syncBufferProgress = () => {
      if (settled) return;
      let ratio = 0.1;

      if (ctaVideo.readyState >= 4) ratio = 1;
      else if (ctaVideo.readyState >= 3) ratio = 0.85;
      else if (ctaVideo.readyState >= 2) ratio = 0.55;
      else if (ctaVideo.readyState >= 1) ratio = 0.28;

      try {
        if (ctaVideo.buffered && ctaVideo.buffered.length && ctaVideo.duration > 0) {
          const end = ctaVideo.buffered.end(ctaVideo.buffered.length - 1);
          ratio = Math.max(ratio, Math.min(1, end / Math.min(ctaVideo.duration, 8)));
        }
      } catch (e) {
        /* ignore */
      }

      videoRatio = ratio;
      syncCombinedProgress();

      if (ctaVideo.readyState >= 3) {
        videoReady = true;
        finish();
      }
    };

    ctaVideo.addEventListener('loadstart', () => {
      videoRatio = Math.max(videoRatio, 0.08);
      syncCombinedProgress();
    });
    ctaVideo.addEventListener('progress', syncBufferProgress);
    ctaVideo.addEventListener('loadeddata', syncBufferProgress);
    ctaVideo.addEventListener(
      'canplay',
      () => {
        videoReady = true;
        videoRatio = Math.max(videoRatio, 0.9);
        syncCombinedProgress();
        finish();
      },
      { once: true }
    );
    ctaVideo.addEventListener(
      'canplaythrough',
      () => {
        videoReady = true;
        videoRatio = 1;
        syncCombinedProgress();
        finish();
      },
      { once: true }
    );
    ctaVideo.addEventListener(
      'error',
      () => {
        videoReady = true;
        videoRatio = 1;
        syncCombinedProgress();
        finish();
      },
      { once: true }
    );

    if (ctaVideo.readyState >= 3) {
      videoReady = true;
      syncBufferProgress();
      finish();
    } else {
      syncBufferProgress();
      try {
        ctaVideo.load();
      } catch (e) {
        /* ignore */
      }
    }

    window.setTimeout(() => {
      videoReady = true;
      finish();
    }, FALLBACK_MS);
  };

  bootCtaVideo();

  const playIntro = () => {
    if (!stage || !cta) return;
    if (!ctaReady) return;
    if (stage.classList.contains('is-playing')) return;
    stage.classList.add('is-playing', 'cta-hidden');
    if (ctaVideo) {
      try {
        ctaVideo.pause();
      } catch (e) {
        /* ignore */
      }
    }
    startMusic();

    if (reduceMotion) {
      unlockPage();
      return;
    }

    const sequence = [
      ['step-part', 0],
      ['step-vdrop', 900],
      ['step-yellowfill', 2500],
      ['step-hdrop', 3800],
      ['step-hgold', 5050],
      ['step-redfill', 6100],
      ['step-logos', 7000],
    ];

    sequence.forEach(([className, delay]) => {
      window.setTimeout(() => {
        stage.classList.add(className);
        if (className === 'step-yellowfill') morphYellow();
      }, delay);
    });

    // Fin d’animation → landing
    window.setTimeout(unlockPage, 9300);
  };

  document.body.classList.add('r1617-locked');

  if (cta) {
    cta.addEventListener('click', playIntro);
  } else {
    unlockPage();
  }

  /* —— Topbar (logo + retour) & sticky ATC : visibles au scroll seulement —— */
  window.addEventListener('scroll', updateTopbarScroll, { passive: true });
  window.addEventListener('scroll', updatePillsVisibility, { passive: true });
  window.addEventListener('resize', updatePillsVisibility, { passive: true });
  if (pills) pills.classList.remove('is-visible');
  updateTopbarScroll();
  updatePillsVisibility();

  /* —— Modals —— */
  const modals = Array.from(root.querySelectorAll('[data-r1617-modal]'));
  let lastFocus = null;

  const getModal = (name) =>
    modals.find((modal) => modal.getAttribute('data-r1617-modal') === name);

  const pauseBedForVideoModal = () => {
    if (!musicStarted) return;
    bedDucked = true;
    applyBedLevel();
    if (!usingWebAudio && bedEl) {
      try {
        bedEl.pause();
      } catch (e) {
        /* ignore */
      }
    }
  };

  const resumeBedAfterVideoModal = () => {
    if (!musicStarted) return;
    bedDucked = false;
    applyBedLevel();
    if (audioCtx && audioCtx.state === 'suspended') {
      audioCtx.resume().catch(() => {});
    }
    if (!usingWebAudio && bedEl && effectiveLevel() > 0) {
      bedEl.play().catch(() => {});
    }
  };

  const closeModal = (modal) => {
    if (!modal || modal.hidden) return;

    const wasVideoModal = modal.getAttribute('data-r1617-modal') === 'video';

    modal.hidden = true;
    document.body.classList.remove('r1617-modal-open');

    const video = modal.querySelector('[data-r1617-video-player]');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    if (wasVideoModal) {
      resumeBedAfterVideoModal();
    }

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  };

  const openModal = (name, trigger) => {
    const modal = getModal(name);
    if (!modal) return;

    modals.forEach((open) => {
      if (!open.hidden && open !== modal) closeModal(open);
    });

    lastFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.body.classList.add('r1617-modal-open');

    const closeBtn = modal.querySelector('[data-r1617-close-modal]');
    if (closeBtn) closeBtn.focus();

    if (name === 'video') {
      pauseBedForVideoModal();
    }

    const video = modal.querySelector('[data-r1617-video-player]');
    if (video) {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  };

  const videoTrigger = root.querySelector('[data-r1617-open-video]');
  const revealVideo = root.querySelector('[data-r1617-video-player]');
  const videoModal = getModal('video');
  let revealFsListening = false;

  const prepVideoHost = () => {
    if (!videoModal) return;
    /* Sortir de hidden (display:none bloque play/fullscreen) sans montrer la modale */
    videoModal.hidden = false;
    videoModal.classList.add('is-fs-prep');
  };

  const hideVideoHost = () => {
    if (!videoModal || document.body.classList.contains('r1617-modal-open')) return;
    videoModal.classList.remove('is-fs-prep');
    videoModal.hidden = true;
  };

  const isRevealVideoFullscreen = () => {
    if (!revealVideo) return false;
    if (document.fullscreenElement === revealVideo) return true;
    if (document.webkitFullscreenElement === revealVideo) return true;
    if (typeof revealVideo.webkitDisplayingFullscreen === 'boolean') {
      return revealVideo.webkitDisplayingFullscreen;
    }
    return false;
  };

  const exitRevealVideo = () => {
    if (!revealVideo) return;
    try {
      revealVideo.pause();
      revealVideo.currentTime = 0;
    } catch (e) {
      /* ignore */
    }
    hideVideoHost();
    resumeBedAfterVideoModal();
  };

  const enterRevealFullscreen = () => {
    if (!revealVideo) return Promise.reject();

    /* iOS Safari : plein écran natif du <video> */
    if (typeof revealVideo.webkitEnterFullscreen === 'function') {
      try {
        revealVideo.webkitEnterFullscreen();
        return Promise.resolve();
      } catch (e) {
        /* fall through */
      }
    }

    if (typeof revealVideo.requestFullscreen === 'function') {
      return revealVideo.requestFullscreen();
    }
    if (typeof revealVideo.webkitRequestFullscreen === 'function') {
      return Promise.resolve(revealVideo.webkitRequestFullscreen());
    }
    if (typeof revealVideo.msRequestFullscreen === 'function') {
      return Promise.resolve(revealVideo.msRequestFullscreen());
    }
    return Promise.reject();
  };

  const playRevealFullscreen = (trigger) => {
    if (!revealVideo) {
      openModal('video', trigger);
      return;
    }

    pauseBedForVideoModal();
    prepVideoHost();

    const onFsChange = () => {
      if (!isRevealVideoFullscreen()) {
        document.removeEventListener('fullscreenchange', onFsChange);
        document.removeEventListener('webkitfullscreenchange', onFsChange);
        revealFsListening = false;
        exitRevealVideo();
      }
    };

    if (!revealFsListening) {
      revealFsListening = true;
      document.addEventListener('fullscreenchange', onFsChange);
      document.addEventListener('webkitfullscreenchange', onFsChange);
    }

    revealVideo.addEventListener('webkitendfullscreen', exitRevealVideo, { once: true });
    revealVideo.addEventListener(
      'ended',
      () => {
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          const exitFs =
            document.exitFullscreen ||
            document.webkitExitFullscreen ||
            document.msExitFullscreen;
          if (exitFs) {
            try {
              exitFs.call(document);
            } catch (e) {
              /* ignore */
            }
          }
        }
        exitRevealVideo();
      },
      { once: true }
    );

    const fallbackModal = () => {
      document.removeEventListener('fullscreenchange', onFsChange);
      document.removeEventListener('webkitfullscreenchange', onFsChange);
      revealFsListening = false;
      if (videoModal) videoModal.classList.remove('is-fs-prep');
      openModal('video', trigger);
    };

    const afterPlay = () => enterRevealFullscreen().catch(fallbackModal);

    const playPromise = revealVideo.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(afterPlay).catch(() => {
        enterRevealFullscreen()
          .then(() => revealVideo.play().catch(() => {}))
          .catch(fallbackModal);
      });
    } else {
      afterPlay();
    }
  };

  if (videoTrigger) {
    videoTrigger.addEventListener('click', () => playRevealFullscreen(videoTrigger));
  }

  root.querySelectorAll('[data-r1617-close-modal]').forEach((el) => {
    el.addEventListener('click', () => {
      const modal = el.closest('[data-r1617-modal]');
      closeModal(modal);
    });
  });

  /* —— Lightbox (galerie + photos kits) —— */
  const lightboxSets = {};
  root.querySelectorAll('[data-r1617-lightbox-data]').forEach((el) => {
    const key = el.getAttribute('data-r1617-lightbox-data');
    if (!key) return;
    try {
      lightboxSets[key] = JSON.parse(el.textContent || '[]');
    } catch (error) {
      lightboxSets[key] = [];
    }
  });

  const galleryStage = root.querySelector('[data-r1617-gallery-stage]');
  let lightboxItems = [];
  let galleryIndex = 0;

  const renderGallery = () => {
    if (!galleryStage || !lightboxItems.length) return;
    const item = lightboxItems[galleryIndex];
    if (!item) return;
    galleryStage.src = item.src;
    const lang = getLang();
    galleryStage.alt =
      (lang === 'en' && item.alt_en ? item.alt_en : item.alt) || item.alt_en || '';
  };

  root.addEventListener('r1617:langchange', () => {
    if (lightboxItems.length) renderGallery();
  });

  const openLightbox = (key, index, trigger) => {
    const items = lightboxSets[key] || [];
    if (!items.length) return;
    lightboxItems = items;
    galleryIndex = Math.max(0, Math.min(Number(index) || 0, items.length - 1));
    renderGallery();
    openModal('gallery', trigger);
  };

  root.querySelectorAll('[data-r1617-lightbox-item]').forEach((btn) => {
    btn.addEventListener('click', () => {
      openLightbox(btn.getAttribute('data-lightbox'), btn.getAttribute('data-index'), btn);
    });
  });

  const galleryPrev = root.querySelector('[data-r1617-gallery-prev]');
  const galleryNext = root.querySelector('[data-r1617-gallery-next]');

  if (galleryPrev) {
    galleryPrev.addEventListener('click', () => {
      if (!lightboxItems.length) return;
      galleryIndex = (galleryIndex - 1 + lightboxItems.length) % lightboxItems.length;
      renderGallery();
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', () => {
      if (!lightboxItems.length) return;
      galleryIndex = (galleryIndex + 1) % lightboxItems.length;
      renderGallery();
    });
  }

  const galleryModal = getModal('gallery');
  if (galleryModal) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchActive = false;

    galleryModal.addEventListener(
      'touchstart',
      (event) => {
        if (!lightboxItems.length || event.touches.length !== 1) return;
        touchActive = true;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    galleryModal.addEventListener(
      'touchend',
      (event) => {
        if (!touchActive || !lightboxItems.length) return;
        touchActive = false;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const dx = touch.clientX - touchStartX;
        const dy = touch.clientY - touchStartY;
        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        /* Swipe horizontal prioritaire, seuil ~48px */
        if (absX < 48 || absX < absY * 1.2) return;

        if (dx < 0) {
          galleryIndex = (galleryIndex + 1) % lightboxItems.length;
        } else {
          galleryIndex = (galleryIndex - 1 + lightboxItems.length) % lightboxItems.length;
        }
        renderGallery();
      },
      { passive: true }
    );

    galleryModal.addEventListener(
      'touchcancel',
      () => {
        touchActive = false;
      },
      { passive: true }
    );
  }

  document.addEventListener('keydown', (event) => {
    const open = modals.find((modal) => !modal.hidden);
    if (!open) return;

    if (event.key === 'Escape') {
      closeModal(open);
      return;
    }

    if (open.getAttribute('data-r1617-modal') !== 'gallery' || !lightboxItems.length) return;

    if (event.key === 'ArrowLeft') {
      galleryIndex = (galleryIndex - 1 + lightboxItems.length) % lightboxItems.length;
      renderGallery();
    } else if (event.key === 'ArrowRight') {
      galleryIndex = (galleryIndex + 1) % lightboxItems.length;
      renderGallery();
    }
  });

  /* —— Product piano + ATC —— */
  const findVariant = (variants, selections) =>
    variants.find((variant) =>
      selections.every((value, index) => variant[`option${index + 1}`] === value)
    );

  root.querySelectorAll('[data-r1617-product-form]').forEach((form) => {
    const variantsEl = form.querySelector('[data-r1617-variants]');
    const variantInput = form.querySelector('[data-r1617-variant-id]');
    const priceEl = form.querySelector('[data-r1617-product-price]');
    const atcBtn = form.querySelector('[data-r1617-atc]');
    const atcLabel = form.querySelector('[data-r1617-atc-label]');
    let variants = [];

    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
    } catch (error) {
      variants = [];
    }

    const getSelections = () => {
      const options = Array.from(form.querySelectorAll('[data-r1617-option]:checked'));
      if (!options.length) return [];

      const byPosition = {};
      options.forEach((input) => {
        byPosition[input.getAttribute('data-option-position')] = input.value;
      });

      return Object.keys(byPosition)
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => byPosition[key]);
    };

    const syncVariant = () => {
      if (!variants.length || !variantInput) return;

      const selections = getSelections();
      const variant =
        (selections.length && findVariant(variants, selections)) ||
        variants.find((item) => item.available) ||
        variants[0];

      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
      }

      if (atcLabel) {
        atcLabel.textContent = variant.available
          ? atcLabelFor(atcBtn, 'atc') || 'Ajouter au panier'
          : atcLabelFor(atcBtn, 'soldout') || 'Rupture';
      }

      form.querySelectorAll('.r1617-product__key').forEach((label) => {
        const input = label.querySelector('input');
        if (!input) return;

        const position = Number(input.getAttribute('data-option-position'));
        const trial = getSelections().slice();
        trial[position - 1] = input.value;
        const match = findVariant(variants, trial);
        label.classList.toggle('is-unavailable', !(match && match.available));
      });
    };

    form.querySelectorAll('[data-r1617-option]').forEach((input) => {
      input.addEventListener('change', syncVariant);
    });

    syncVariant();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!atcBtn || atcBtn.disabled) return;

      const formData = new FormData(form);
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = atcLabelFor(atcBtn, 'adding') || 'Ajout…';

      try {
        const response = await fetch(
          window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
          {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          }
        );

        if (!response.ok) throw new Error('add_failed');

        if (atcLabel) atcLabel.textContent = atcLabelFor(atcBtn, 'added') || 'Ajouté';
        window.setTimeout(() => {
          if (atcLabel) atcLabel.textContent = atcLabelFor(atcBtn, 'atc') || 'Ajouter au panier';
          atcBtn.disabled = false;
        }, 1200);
      } catch (error) {
        if (atcLabel) atcLabel.textContent = atcLabelFor(atcBtn, 'error') || 'Erreur';
        window.setTimeout(() => {
          syncVariant();
        }, 1200);
      }
    });

    root.addEventListener('r1617:langchange', () => {
      syncVariant();
    });
  });
})();
